module.exports = "https://cdn2-fs.clearscore.com/flux/images/077c1fa441a025b789b1f54f1944ebfd.jpg";